var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "airalo-pages"
  }, [_c('PageTitle', {
    attrs: {
      "title": _vm.$t('components.main.navigation.airalo.careers.job-vacancies'),
      "bordered": true,
      "back-button": {
        url: 'airalo-careers-working-at-airalo',
        hiddenAfterSizes: 'sm'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-20 px-md-30 py-30 pt-md-0 pb-md-30 pb-lg-40"
  }, [_c('breadcrumb', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', {
    staticClass: "display-grid grid-cols-1 grid-cols-md-10 grid-cols-lg-12 gap-10 w-100"
  }, [_c('div', {
    staticClass: "col-span-md-10 col-start-lg-2"
  }, [_c('Card', {
    attrs: {
      "title": _vm.heroContent.title,
      "description-element": _vm.heroContent.description,
      "image-url": `/assets/images/airalo-careers/join-the-airalo-team-v2.png`,
      "is-reverse": true
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "px-20 px-md-30 pt-30 pt-lg-40 bg-white"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', {
    staticClass: "display-flex flex-column justify-content-start align-items-start"
  }, [_c('h2', {
    staticClass: "typo-h3 typo-md-h1 mb-0 w-100",
    class: {
      'text-left': _vm.$dir() === 'ltr',
      'text-right': _vm.$dir() === 'rtl'
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('scenes.job.vacancies.current-opportunities-title')) + "\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "display-none display-md-block typo-h3 typo-md-h4-right mb-0 w-100 mt-40",
    class: {
      'text-left': _vm.$dir() === 'ltr',
      'text-right': _vm.$dir() === 'rtl'
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('scenes.job.vacancies.choose-a-department-title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "department-list"
    }
  }, [_c('div', {
    staticClass: "display-none display-md-flex flex-wrap align-items-center justify-content-start gap-20 gap-md-30 w-100 mt-30 pb-50"
  }, [_c('div', {
    class: ['shadowed box-rounded-corner px-24 pt-17 pb-16 display-flex align-items-center gap-10 text-decoration-none tw-cursor-pointer', {
      'color-text-white color-bg-primary': _vm.selectedDepartment === 'all',
      'color-text-primary color-bg-white': _vm.selectedDepartment !== 'all'
    }],
    on: {
      "click": function ($event) {
        return _vm.onChangeFilter('all', 'department');
      }
    }
  }, [_c('p', {
    staticClass: "typo-h6 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('global.all')))])]), _vm._v(" "), _vm._l(_vm.departments, function (item, index) {
    return _c('div', {
      key: `departments-item-${index}`,
      class: ['shadowed box-rounded-corner px-24 pt-17 pb-16 display-flex align-items-center gap-10 text-decoration-none tw-cursor-pointer', {
        'color-text-white color-bg-primary': _vm.selectedDepartment === item.slug,
        'color-text-primary color-bg-white': _vm.selectedDepartment !== item.slug
      }],
      on: {
        "click": function ($event) {
          return _vm.onChangeFilter(item.slug, 'department');
        }
      }
    }, [_c('p', {
      staticClass: "typo-h6 mb-0"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "typo-p-small color-text-secondary mb-0"
    }, [_vm._v("\n              ["), _c('span', {
      class: {
        'color-text-white': _vm.selectedDepartment === item.slug,
        'color-text-primary': _vm.selectedDepartment !== item.slug
      }
    }, [_vm._v(_vm._s(item.jobs))]), _vm._v("]\n            ")])]);
  })], 2), _vm._v(" "), _vm.departmentsMobile && _vm.departmentsMobile.options ? _c('div', {
    class: ['w-100 display-md-none mt-20', {
      'pb-30': !_vm.isShowEmptyMessage && _vm.opportunities.paginatedList.length === 0
    }]
  }, [_c('DropDown', {
    attrs: {
      "id": "departments",
      "label": _vm.getDepartmentsMobileLabel('components.filter.dropdown.label.depatment-title'),
      "options": _vm.departmentsMobile.options,
      "selected": _vm.departmentsMobile.selected
    },
    on: {
      "onChange": function ($event) {
        return _vm.onChangeFilter($event, 'department');
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), !_vm.isShowEmptyMessage && _vm.opportunities.paginatedList.length > 0 ? [_c('div', {
    class: ['display-none display-md-flex flex-wrap align-items-center justify-content-start gap-20 w-100 pt-20 border-t border-t-solid color-border-top-lighter'],
    attrs: {
      "dir": "auto"
    }
  }, [_c('h4', {
    staticClass: "typo-h6 mb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('scenes.job.vacancies.filter-title')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "display-grid grid-cols-1 grid-cols-lg-3 gap-20 mt-20 mt-md-25 border-b border-b-solid color-border-bottom-lighter pb-25"
  }, [_vm.jobTitle.options.length > 0 ? [_c('DropDown', {
    attrs: {
      "id": "jobTitle",
      "label": _vm.jobTitle.label,
      "options": _vm.jobTitle.options,
      "selected": _vm.jobTitle.selected,
      "direction": "auto"
    },
    on: {
      "onChange": function ($event) {
        return _vm.onChangeFilter($event, 'title');
      }
    }
  })] : _vm._e(), _vm._v(" "), _vm.countries.options.length > 0 ? [_c('DropDown', {
    attrs: {
      "id": "countries",
      "label": _vm.countries.label,
      "options": _vm.countries.options,
      "selected": _vm.countries.selected,
      "direction": "auto"
    },
    on: {
      "onChange": function ($event) {
        return _vm.onChangeFilter($event, 'location');
      }
    }
  })] : _vm._e(), _vm._v(" "), _vm.roleType.options.length > 0 ? [_c('DropDown', {
    attrs: {
      "id": "roleType",
      "label": _vm.roleType.label,
      "options": _vm.roleType.options,
      "selected": _vm.roleType.selected,
      "direction": "auto"
    },
    on: {
      "onChange": function ($event) {
        return _vm.onChangeFilter($event, 'commitment');
      }
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "display-grid grid-cols-1 grid-cols-sm-2 grid-cols-md-3 grid-cols-lg-4 gap-10 gap-md-22 mt-25 pb-30 pb-lg-40",
    attrs: {
      "dir": "auto"
    }
  }, [_vm._l(_vm.opportunities.paginatedList, function (item, index) {
    return _c('div', {
      key: `opportunities-item-${index}`,
      staticClass: "box-rounded shadowed p-25 p-md-24 display-flex flex-column justify-content-start align-items-start minh-260 z-index-5 position-relative"
    }, [_c('div', {
      staticClass: "border-b border-b-solid color-border-bottom-very-lighter pb-10 w-100"
    }, [_c('p', {
      staticClass: "typo-h6 color-text-secondary mb-0"
    }, [_vm._v("\n                " + _vm._s(_vm.getLocationText(item.location)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "mt-20 mb-10 w-100"
    }, [_c('a', {
      staticClass: "typo-h4-right color-text-primary mb-0",
      attrs: {
        "href": item.urls.show,
        "target": "_blank"
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "mt-auto w-100"
    }, [_c('p', {
      staticClass: "typo-p-small color-text-secondary mb-0"
    }, [_vm._v("- " + _vm._s(item.commitment))]), _vm._v(" "), _c('p', {
      staticClass: "typo-p-small color-text-secondary mb-0 mt-10"
    }, [_vm._v("- " + _vm._s(item.department))])]), _vm._v(" "), item.urls && item.urls.apply && item.urls.show ? [_c('div', {
      staticClass: "mt-20 w-100"
    }, [_c('a', {
      staticClass: "button button-secondary-outline small-md w-100",
      attrs: {
        "href": item.urls.show,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('global.view-details', 'en')) + "\n                ")]), _vm._v(" "), _c('a', {
      staticClass: "button button-secondary small-md tw-bordertw-border tw-border-solid tw-border-primary w-100 tw-mt-2.5 md:tw-mt-4",
      attrs: {
        "href": item.urls.apply,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('global.apply-now', 'en')) + "\n                ")])])] : _vm._e()], 2);
  }), _vm._v(" "), _c('client-only', [_vm.opportunities.filtered && _vm.opportunities.filtered.length > 0 ? _c('infinite-loading', {
    attrs: {
      "identifier": _vm.infiniteId
    },
    on: {
      "infinite": _vm.infiniteScroll
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('div', {
    staticClass: "load-more-preloader mt-10 relative"
  }, [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  })]) : _vm._e()], 1)], 2)] : _vm.isShowEmptyMessage ? [_c('div', {
    staticClass: "no-jobs py-40 py-lg-0 display-flex justify-content-center align-items-end"
  }, [_c('div', {
    staticClass: "display-flex justify-content-center justify-content-lg-between align-items-end w-100",
    staticStyle: {
      "min-height": "135px"
    }
  }, [_c('div', {
    staticClass: "no-jobs-image display-none display-lg-flex justify-content-start align-items-end"
  }, [_c('nuxt-img', {
    class: {
      'w-100 h-auto': !_vm.deviceType.isMobile,
      'w-auto h-100': _vm.deviceType.isMobile
    },
    attrs: {
      "src": "/assets/images/airalo-careers/no-jobs-1.svg",
      "alt": "",
      "height": "465",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "typo-h5-regular color-text-secondary text-center w-100 mb-auto mt-auto"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('scenes.job.vacancies.empty-state')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "no-jobs-image display-none display-lg-flex"
  }, [_c('nuxt-img', {
    class: {
      'w-100 h-auto': !_vm.deviceType.isMobile,
      'w-auto h-100': _vm.deviceType.isMobile
    },
    attrs: {
      "src": "/assets/images/airalo-careers/no-jobs-2.svg",
      "alt": "",
      "height": "465",
      "loading": "lazy"
    }
  })], 1)])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "px-20 px-md-30 py-30 py-lg-40"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', [_c('BottomBanner', {
    attrs: {
      "image-url": "/assets/images/airalo-careers/job-vacancies-banner.jpg"
    }
  }, [_c('div', {
    staticClass: "display-flex flex-column justify-content-center align-items-center w-100"
  }, [_c('h2', {
    staticClass: "typo-h1 mb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.title')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "typo-p mb-0 mt-10 text-center"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.subtitle')) + "\n            ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "button button-secondary btn-primary-hv shadowed minw-224 mt-20 text-center",
    attrs: {
      "to": _vm.localePath({
        name: 'airalo-careers-working-at-airalo'
      })
    },
    nativeOn: {
      "click": function ($event) {
        _vm.sendEventHandler({
          text: _vm.$t('components.banner.job.vacancies.button-title'),
          url: _vm.localePath({
            name: 'airalo-careers-working-at-airalo'
          })
        });
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.button-title')) + "\n            ")])], 1)])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }